import React from 'react';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Card } from '../components/ui/Card';
import { Globe, Award, Shield, Users } from 'lucide-react';
export function Unternehmen() {
  return <div className="pb-20" data-id="element-454">
      {/* Hero */}
      <section className="pt-20 pb-16 bg-[#0f0f16]" data-id="element-455">
        <div className="container mx-auto px-4 md:px-6 text-center" data-id="element-456">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6" data-id="element-457">
            Über TIKA Mobility
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto mb-8" data-id="element-458">
            Wir gestalten die Zukunft des Fahrzeugzugangs. Sicher, digital und
            weltweit vernetzt.
          </p>
        </div>
      </section>

      {/* Story */}
      <section className="py-16 bg-[#0a0a0f]" data-id="element-459">
        <div className="container mx-auto px-4 md:px-6" data-id="element-460">
          <div className="max-w-4xl mx-auto" data-id="element-461">
            <h2 className="text-2xl font-bold text-white mb-6" data-id="element-462">
              Unsere Mission
            </h2>
            <p className="text-gray-300 text-lg leading-relaxed mb-8" data-id="element-463">
              TIKA Mobility ist ein Projekt der PEZULA Projects & Experts GmbH.
              Gemeinsam mit unseren Partnern haben wir über drei Jahrzehnte
              Erfahrung in der Automobilelektronik und Softwareentwicklung. Wir
              wollen uns als der führende Technologie-Provider für digitale
              Fahrzeugschlüssel-Lösungen am europäischen Markt etablieren, indem
              wir Hardware-Präzision mit moderner Cloud-Technologie verbinden.
            </p>
            <p className="text-gray-300 text-lg leading-relaxed mb-12" data-id="element-464">
              Unser globales Netzwerk kombiniert Entwicklung, Produktion und
              technischen Service, um Kunden europaweit zu unterstützen. Wir
              glauben daran, dass der physische Schlüssel ein Relikt der
              Vergangenheit ist – die Zukunft gehört dem Smartphone.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-12" data-id="element-465">
            {[{
            icon: Globe,
            title: 'Globale Präsenz',
            desc: 'Standorte in Europa, Asien und Nordamerika.'
          }, {
            icon: Award,
            title: '140+ Patente',
            desc: 'Führend in Innovation und IP-Schutz.'
          }, {
            icon: Shield,
            title: 'ISO Zertifiziert',
            desc: 'Höchste Qualitäts- und Sicherheitsstandards.'
          }, {
            icon: Users,
            title: 'Experten-Team',
            desc: 'Über 500 Ingenieure und Entwickler.'
          }].map((item, i) => <Card key={i} className="text-center" data-id="element-466">
                <item.icon className="w-10 h-10 text-cyan-400 mx-auto mb-4" data-id="element-467" />
                <h3 className="font-bold text-white mb-2" data-id="element-468">{item.title}</h3>
                <p className="text-sm text-gray-400" data-id="element-469">{item.desc}</p>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Image Banner */}
      <section className="py-12" data-id="element-470">
        <div className="container mx-auto px-4" data-id="element-471">
          <div className="rounded-2xl overflow-hidden h-80 relative" data-id="element-472">
            <img src="https://cdn.magicpatterns.com/uploads/7GX6js9XS5Tc23DpHmeUXE/364314226.jpg" alt="Team working" className="w-full h-full object-cover" data-id="element-473" />
            <div className="absolute inset-0 bg-cyan-900/20 mix-blend-multiply" data-id="element-474" />
          </div>
        </div>
      </section>
    </div>;
}